import type { ReactNode } from 'react';

/** The plain page around sign-in, invitations and choosing books: no menu, no data. */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="el-auth">
      <section className="el-auth-card" aria-labelledby="auth-title">
        <div className="el-auth-brand">
          <span className="el-brand-mark" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 3h10M3 8h10M3 13h6" stroke="#9FE1CB" strokeWidth="1.6" strokeLinecap="round" /></svg>
          </span>
          Elysian Ledger
        </div>
        <h1 id="auth-title">{title}</h1>
        {children}
      </section>
    </main>
  );
}
